import { Identifiable, Project, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";

type Response = Identifiable<Project>;

function deserializeLinks(data: { [key: string]: string }) {
  return JSON.parse(data.externalLinks || "[]");
}

function serializeLinks(data: { [key: string]: string }) {
  return JSON.stringify(data.externalLinks || "[]");
}

function duplicateModelFromProject(httpClient: HttpClient) {
  return (project: Identifiable<Project>, projectModel: Project) =>
    httpClient.sendHttpRequest<Response>({
      endpoint: `/projects/${project.uuid}/create-template`,
      method: HttpMethods.POST,
      data: {
        name: projectModel.name,
        description: projectModel.description,
        ...(projectModel.rootList.startDate && {
          startDate: formatDate(projectModel.rootList.startDate),
        }),
        ...(projectModel.rootList.endDate && {
          endDate: formatDate(projectModel.rootList.endDate),
        }),
        status: `projectStatuses/${projectModel.status.uuid}`,
        tags: projectModel.tags.map((tag) =>
          typeof tag === "string" ? tag : tag.name,
        ),
        attributes: projectModel.attributes,
        data: {
          externalLinks: serializeLinks(deserializeLinks(project.data)),
        },
      },
    });
}

export { duplicateModelFromProject };
